exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-item[data-v-3219ee74]{background:transparent;border:0;box-shadow:none;color:#586678;cursor:pointer;font-weight:400\n}", ""]);

// exports
